import React from 'react'

function ChilledBeamDKF() {
  return (
    <embed src="\pdfs\E2.4.1_DK-F_Chilled_beam_05.2005_kr.pdf" width="100%" height="2100px" />
  )
}

export default ChilledBeamDKF